
import { studentStateType } from '../types'

const userNameErr           = 'חובה לציין שם משתמש';
const userEmailErr          = `חובה לציין כתובת דוא״ל`;
const invalidEmailErr       = `חובה להזין כתובת דוא״ל תקינה`;
const schoolNameErr         = `חובה לציין את שם בית הספר`;
const cityErr               = `חובה לציין את שם הישוב`;
const teacherNameErr        = `חובה לציין את שם המורה למתמטיקה`;
const allowNotificationsErr = `חובה לציין אם ברצונך לקבל מידע אודות פעילויות נוספות של יישומטיקה`;
const arabicErr             = `חובה לציין אם הנך דובר ערבית`;


const validateEmail = (email: string) => {
   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   return re.test(String(email).toLowerCase());
}

const errorCreator = (val: studentStateType) => {

   if ( !val.userName.length )           { return userNameErr }
   if ( !val.userEmail.length )          { return userEmailErr }
   if ( !validateEmail(val.userEmail) )  { return invalidEmailErr }
   if ( !val.schoolName.length )         { return schoolNameErr }
   if ( !val.city.length )               { return cityErr }
   if ( !val.teacherName.length )        { return teacherNameErr }
   if ( !val.allowNotifications.length ) { return allowNotificationsErr }
   if ( !val.arabic.length )             { return arabicErr }

   return ''
}

export default errorCreator